import React from "react";
import PropTypes from "prop-types";
import { overrideTailwindClasses } from "tailwind-override";

const RTRRadioInputPair = React.forwardRef(
  (
    {
      additionalClasses = {},
      checked,
      defaultChecked,
      dataTestId = "radio-input-pair",
      disabled,
      id,
      label,
      name,
      onChange,
      value,
    },
    forwardedRef
  ) => {
    const {
      containerOverrides = "",
      inputContainerOverride = "",
      inputOverride = "",
      inputFilledOverride = "",
      labelOverride = "",
    } = additionalClasses;
    const baseRadioInputClass = "col-start-1 row-start-1";
    const containerClass = overrideTailwindClasses(`flex gap-1.5 ${containerOverrides}`);
    const inputContainerClass = overrideTailwindClasses(`grid place-items-center size-5 ${inputContainerOverride}`);
    const inputClass = overrideTailwindClasses(`
      peer
      !opacity-100
      ${baseRadioInputClass}
      appearance-none shrink-0 
      size-5
      border border-solid border-darkGray rounded-full
      checked:border-black
      disabled:border-darkerGray !cursor-default
      ${inputOverride}
    `);
    const inputFilledClass = overrideTailwindClasses(`
      pointer-events-none
      ${baseRadioInputClass}
      size-3 rounded-full 
      peer-checked:bg-black
      peer-disabled:text-darkerGray !cursor-default 
      ${inputFilledOverride}
    `);
    const labelClass = overrideTailwindClasses(`
      flex items-start gap-2 
      !font-sans !text-md !normal-case !tracking-normal
      !m-0
      ${disabled && "text-darkGray !cursor-default"}
      ${labelOverride}
    `);

    return (
      <div className={containerClass} data-test-id={dataTestId} ref={forwardedRef}>
        <div className={inputContainerClass}>
          <input
            className={inputClass}
            defaultChecked={defaultChecked}
            checked={checked}
            id={id}
            key="input"
            name={name}
            onChange={onChange}
            type="radio"
            disabled={disabled}
            value={value}
          />
          <div className={inputFilledClass} />
        </div>
        <label htmlFor={id} className={labelClass}>
          {label}
        </label>
      </div>
    );
  }
);

RTRRadioInputPair.displayName = "RTRRadioInputPair";

RTRRadioInputPair.propTypes = {
  additionalClasses: PropTypes.shape({
    containerOverrides: PropTypes.string,
    inputContainerOverride: PropTypes.string,
    inputOverride: PropTypes.string,
    inputFilledOverride: PropTypes.string,
    labelOverride: PropTypes.string,
  }),
  checked: PropTypes.bool,
  dataTestId: PropTypes.string,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
export default RTRRadioInputPair;
